import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["ConjunctiveFacet", "DisjunctiveFacet", "facetType"];
import React, { Component } from 'react';
import { CONJUNCTIVE_FACET_TYPE, DISJUNCTIVE_FACET_TYPE } from '../../../../../common/records/FacetType';
export default class FacetContent extends Component {
  render() {
    const _this$props = this.props,
      {
        ConjunctiveFacet,
        DisjunctiveFacet,
        facetType
      } = _this$props,
      otherProps = _objectWithoutProperties(_this$props, _excluded);
    switch (facetType) {
      case DISJUNCTIVE_FACET_TYPE:
        return /*#__PURE__*/React.createElement(DisjunctiveFacet, otherProps);
      case CONJUNCTIVE_FACET_TYPE:
        return /*#__PURE__*/React.createElement(ConjunctiveFacet, otherProps);
      default:
        console.error("Invalid facet type '".concat(facetType, "'."));
    }
  }
}